import React from 'react';
import CardImage from './cardImage';
import CardInfo from './cardInfo';
import {connect} from 'react-redux';
import {Link} from 'react-router';


class Card extends React.Component{
  constructor(props) {
     super(props);
     this.onClick = this.onClick.bind(this);
   } 

   onClick(){
     this.props.dispatch({type: 'OFFER_DETAIL_PAGE', payload: this.props.offerDetail});
   }
    render(){

      var offer =this.props.offerDetail.activeKey;

      return (
        <Link to={'/offers-and-coupons/'+offer+'/'}   className={this.props.style} onClick={this.onClick}>

         <div>
        <CardImage imageUrl = {this.props.offerDetail.imageUrl}
                         name = {this.props.offerDetail.offerName}

                          />

        {/*<VenueRating  averageRating={this.props.venueDetail.avgRating}*/}
                      {/*ratingCount ={this.props.venueDetail.ratingCount}  />*/}

        <CardInfo info={this.props.offerDetail}/>
        </div>
       </Link>
      );
    }

}

export default connect()(Card);



// WEBPACK FOOTER //
// ./src/components/Offers/offerCard.js